import FooterLayout from "../footer/footer-layout.js";
import NavigationLayout from "../navigation/navigation-layout.js";
import BlogsLayout from "./blogs/blogs-layout.js";
import ClientsLayout from "./clients/clients-layout.js";
import HeroLayout from "./hero/hero-layout.js";
import LandingStats from "./landingStats/landingStats.js";
import PlatformsLayout from "./platforms/platforms-layout.js";
import TechnologyLayout from "./technology/technology-layout.js";

const LandingLayout = () => {
    return (
        <>
            <NavigationLayout />

            <HeroLayout />

            <PlatformsLayout />

            {/* <ClientsLayout /> */}

            {/* <TechnologyLayout /> */}

            <LandingStats />

            <BlogsLayout />

            <FooterLayout />
        </>
    );
}

export default LandingLayout;